import $ from 'jquery';
import { handleSidebarBackgrounds } from '~src/sidebar/index';
import { modifyState } from '~src/state';

// Tag backgrounds
const onClickImageTag = async (event) => {
  const tagName = $(event.currentTarget).attr('data-name');
  const tagId = $(event.currentTarget).attr('data-id');
  modifyState('sidebarCurrentBackgroundsTag', tagName.toLowerCase());
  await handleSidebarBackgrounds();
  $('#select-ricerca-backgrounds').val(tagId).trigger('change');
};

export const displaySidebarBackgroundsTag = () => {
  const mainTags = window.editorConfig.sidebarTags.items.filter(
    (tag) => tag.isMainCategory === true
  );

  const { ids, html } = mainTags.reduce(
    (acc, item) => {
      const itemId = `editor-sidebar-add-canvas-image-tag-${item.objectId}`;

      acc.html += `<div
                    id="${itemId}"
                    data-name="${item.name}" 
                    data-id="${item.objectId}" 
                    class="block-with-image-tag">
                    <div class="block-image lazy overlay" data-bg="${item.img.url}">
                    </div>
                    <div class="block-name-tag text-center p-3 h5">${item.name}</div>
                  </div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onClickImageTag);
      $('body').on('click', id, onClickImageTag);
    });
  }

  $('#tab-manifesti .items-container-tag-grid').html(html);

  window.lazyLoadInstance.update();
};
